export default {"src":"/_next/static/media/bgDark.19a4a8a0.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};